import React from 'react'

import { ShimmerContainer, SkeletonBox } from '@/components/HomeShimmer/styles'

import { useListItemsByPath, LIST_ITEM_SKELETON_HEIGHT } from './useListItemsByPath'
import type { SDUIComponentProps } from '../interfaces'

interface ListItemSDUIRendererBaseProps<T> {
  sduiComponent: SDUIComponentProps
  inlineItems: T[]
  Component: React.FC<{
    items: T[]
    style?: { marginTop?: string; marginBottom?: string }
    componentAnalytics?: Analytics
  }>
}

export function ListItemSDUIRendererBase<T>({
  sduiComponent,
  inlineItems,
  Component,
}: ListItemSDUIRendererBaseProps<T>) {
  const componentAnalyticsProps = sduiComponent.analytics
    ? { componentAnalytics: sduiComponent.analytics }
    : {}
  const { items, isLoading, hasError, hasPath, hasInlineProps, style } = useListItemsByPath<T>(
    sduiComponent.path,
    inlineItems,
    sduiComponent.style,
  )

  if (hasPath) {
    if (isLoading) {
      return (
        <ShimmerContainer style={style}>
          <SkeletonBox height={LIST_ITEM_SKELETON_HEIGHT} />
        </ShimmerContainer>
      )
    }

    if (hasError || !items?.length) {
      return null
    }

    return <Component items={items} style={style} {...componentAnalyticsProps} />
  }

  if (hasInlineProps) {
    return <Component items={inlineItems} style={style} {...componentAnalyticsProps} />
  }

  return null
}
